import { Component } from 'react';
import { CompiledRoutes, S_COMPONENT } from 'src/routing';

export const DEV_ROOT = 'dev';

export const DEV_ROUTES = new CompiledRoutes(DEV_ROOT, {
	[S_COMPONENT]: Component,
});
